import Axios from "axios"
import { useState } from "react"
import Radio from "consumer/custom/radio"
import Button from "consumer/custom/button"


export default function Pay(props) {

    const consumer_id = props['consumer_id']

    const [payMethod, Set_payMethod] = useState(null)

    async function pay() {
        if(payMethod === null) {
            alert("결제 방법을 선택해 주세요.")
        }
        else if(window.confirm('결제하시겠습니까?')) {
            const result = await Axios
                            .post("/consumer/pay", {
                                consumer_id: consumer_id,
                                pay_method: payMethod
                            })
            const data = result['data']
            if(data['status'] === 'fail') {
                alert(data['message'])
            }
            else if(data['status'] === 'success') {
                const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                if(isMobile) {
                    window.location.replace(data['data']['mobile_url'])
                }
                else {
                    window.location.replace(data['data']['pc_url'])
                }
            }
        }
    }

    return(
        <>
            <div>
                <div
                    style={{
                        marginBottom: "10px"
                    }}
                >
                    <label>결제 방법</label>
                </div>

                <Radio
                    name="pay_method"
                    list={[
                        {
                            name: "신용카드",
                            value: "creditcard"
                        },
                        {
                            name: "카카오페이",
                            value: "kakaopay"
                        },
                        {
                            name: "네이버페이",
                            value: "naverpay"
                        },
                    ]}
                    event={{
                        onClick: function(e) {
                            Set_payMethod(e.currentTarget.value)
                        }
                    }}
                ></Radio>
            </div>

            <Button
                text="결제"
                style={{
                    marginTop: "50px"
                }}
                event={{
                    onClick: function() {
                        pay()
                    }
                }}
            ></Button>
        </>
    )
}